import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Axios from "axios";
import queryString from 'query-string';
import unsuccess from "assets/img/unsuccessPayment.png";
import success from "assets/img/successPayment.png";
import Config from "../../../config.js"
import swal from 'sweetalert'

import styles from "assets/jss/material-kit-react/views/expositionPage.js";
const useStyles = makeStyles(styles);

export default function ExpositionsVerify(props) {

  const classes = useStyles();
  let [authority, setAuthority] = useState(null);
  let [status, setStatus] = useState(null);
  let [show, setShow] = useState(false);
  function Go() {
    //return swal("رویداد از 25 بهمن آغاز خواهد شد، لطفا در زمان مقرر مراجعه فرمایید.")
    window.location.href = "/Expositions/Main/";
  }
  function Back() {
    window.location.href = "/Expositions/";
  }
  const { ...rest } = props;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  useEffect(() => {
    const value = queryString.parse(props.location.search);
    setStatus(value.Status)
    setAuthority(value.Authority)
    Axios.post(Config.api + "Product/Buy/Verify", {
      authority: value.Authority,
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')

        }
      }).then((result) => {
        console.log(result.data.data)
        setShow(true);
      }).catch(err => {
        setShow(true);

        console.log(err)
        if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          props.history.push("/SignIn");
        }
        else if (err && err.response && err.response.status && err.response.status === 422)
          swal("اطلاعات ارسالی نادرست است.");
        else if (err && err.response && err.response.status && err.response.status === 409) {
          swal("اطلاعات ارسالی نادرست است.");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }, []);
  return (
    <div>
      <Header
        color="transparent"
        brand="Material Kit React"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/bg17.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.top}>
                  <div>
                    <img src={status == "NOK" ? unsuccess : success} alt="..." className={imageClasses} />
                  </div>
                  <div className={classes.name}>
                    <h3 className={classes.title}>{status == "NOK" ? "خطا در پرداخت" : "پرداخت موفق"}</h3>
                    <h6>{status == "NOK" ? "در صورت کسر مبلغ، حداکثر تا 72 ساعت به حساب شما بازگردانده می شود." : "ثبت نام شما با موفقیت انجام شد. همکاران ما با شما تماس خواهند گرفت."}</h6>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <br />
                <br />
                <div className={classes.fastAccess + " " + classes.center}>
                  {status == "OK" ?
                    (
                      <div>
                      <Button variant="contained" className={classes.buttonMargin} disabled={!show} onClick={Go} color="primary">
                        ورود به نمایشگاه
                      </Button>
                      <Button variant="contained" className={classes.buttonMargin} onClick={Back} color="default">
                        بازگشت
                      </Button>
                      </div>
                    ) :
                    (
                      <Button variant="contained" onClick={Back} color="default">
                        بازگشت
                      </Button>
                    )
                  }
                </div>
              </GridItem>

            </GridContainer>
            <div className={classes.description}>
              <p>
                {" "}
              </p>
            </div>
            <GridContainer justify="center">
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
